import {Header} from "./Header";
import {Footer} from "./Footer";
import React, {ReactNode, useEffect, useState} from "react";

export const Datapad = ({ children } : { children?: ReactNode }) => {

    const [height, setHeight] = useState<number>(0);

    const Actions = {
        reCalculatedSize: () => {
            const sizes = [
                document.getElementById('DataPad-Header')?.clientHeight ?? 0,
                document.getElementById('DataPad-Footer')?.clientHeight ?? 0,
            ]
            setHeight( sizes.reduce( (a, b) => a + b, 1) )
        }
    }

    useEffect( () => {
        const timer = setTimeout( () => Actions.reCalculatedSize(), 1000 );
        window.addEventListener('resize', (e) => {
            e.preventDefault();
            Actions.reCalculatedSize();
        });
        return () => {
            clearTimeout( timer );
            window.removeEventListener('resize', (e) => {});
        }
    }, [])

    return <>
        <Header />

        <div style={{ height: 'calc(100vh - '+height+'px)', overflowY: 'auto'}}>
            { children }
        </div>

        <Footer />
    </>
}